import { useTranslation } from 'react-i18next';

import { useEditPageContext } from 'components/shared/CRUD/components/InnerPage/EditPageContext';

import WithEditPageLayout, {
  WithEditPageLayoutProps
} from '../../WithEditPageLayout';
import { ControlledCheckboxAutoComplete } from 'components/shared';
import { GrantOption } from './schema';

interface Props {
  grantsCatalog: any;
}

const GRANT_CATALOG_IDS = 'grantCatalogIds';

const PermissionFormFields: React.FC<WithEditPageLayoutProps & Props> = ({
  grantsCatalog,
  methods
}) => {
  const { t } = useTranslation('common');
  const { control, setValue, watch } = methods;

  const { isEditable } = useEditPageContext();

  const grants = grantsCatalog as GrantOption[];

  const onRemoveElement = (id: number | string) => {
    setValue(
      GRANT_CATALOG_IDS,
      watch(GRANT_CATALOG_IDS).filter((sid: number) => sid !== id),
      { shouldDirty: true }
    );
  };

  if (!grants || !grants.length) return null;

  return (
    <ControlledCheckboxAutoComplete
      control={control}
      disabled={!isEditable}
      fullWidth
      idProperty="value"
      label={t('authorizationSettings.edit.searchByLogicalPermissions')}
      labelProperty="label"
      name={GRANT_CATALOG_IDS}
      options={grants}
      allowItemRemoval={isEditable}
      onRemoveElement={onRemoveElement}
    />
  );
};

const PermissionFormFieldsWithLayout = WithEditPageLayout(PermissionFormFields);
export default PermissionFormFieldsWithLayout;
